import React from "react";
import { useSearchParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { CheckCircle, Clock } from "react-feather";
import withStyles from "isomorphic-style-loader/withStyles";
import logo from "../../../media/img/vs-logo-blue.png";
import s from "../dnsSetup/styles.scss";

const TERMINAL_COPY = {
  expired: {
    title: "Link no longer active",
    message:
      "This Stripe onboarding link was already used or is no longer valid. Ask your administrator to send a new Stripe onboarding email.",
  },
  error: {
    title: "Stripe connection failed",
    message:
      "Stripe sign-in finished, but ViewSpark couldn't complete the connection. Ask your administrator to send a new Stripe onboarding email.",
  },
};

const StripeConnectPageShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={s.pageContainer}>
    <div className={s.pageCard}>
      <div className={s.pageLogoWrap}>
        <img src={logo} alt="ViewSpark" className={s.pageLogo} />
      </div>
      {children}
    </div>
  </div>
);

const StripeConnectResultPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  if (status !== "connected") {
    const terminalCopy = TERMINAL_COPY[status === "expired" ? "expired" : "error"];
    return (
      <StripeConnectPageShell>
        <div className={s.errorContainer}>
          <h1 className={s.errorTitle}>{terminalCopy.title}</h1>
          <p className={s.errorMessage}>{terminalCopy.message}</p>
        </div>
      </StripeConnectPageShell>
    );
  }

  return (
    <StripeConnectPageShell>
      <Row className="justify-content-center">
        <Col md="9">
          <div className={s.submittedContainer}>
            <h2 className={s.submittedTitle}>Stripe account connected</h2>
            <p className={s.submittedSubtitle}>
              Your Stripe account has been connected to ViewSpark. You can close this window.
            </p>
            <div className={s.statusList}>
              <div className={s.statusItem}>
                <CheckCircle size={20} className={s.checkIcon} />
                <span className={s.statusText}>Stripe account connected</span>
              </div>
              <div className={s.statusItem}>
                <Clock size={20} className={s.clockIcon} />
                <span className={s.statusText}>
                  Donations are being enabled. A confirmation email will follow shortly.
                </span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </StripeConnectPageShell>
  );
};

export default withStyles(s)(StripeConnectResultPage);
